import React from 'react';
import { Facilities } from '@lt/components';
import Container from '../../components/Container';
import EmptyFacilities from './EmptyFacilities';
import type { FacilitiesContainerProps } from './types';

const FacilitiesContainer = ({
  isMobile,
  attractions,
  kids,
  room,
  territory,
}: FacilitiesContainerProps) =>
  room || attractions || kids || territory ? (
    <Container isMobile={isMobile} white>
      <Facilities
        isMobile={isMobile}
        attractions={attractions}
        kids={kids}
        room={room}
        territory={territory}
      />
    </Container>
  ) : (
    <EmptyFacilities isMobile={isMobile} />
  );

export default FacilitiesContainer;
